import { decodeUri, getSchemeFromValue, needEncoding } from 'libs/urls';

export function getInitialValueState(defaultValue) {
  const scheme = getSchemeFromValue(defaultValue);
  const shouldEncode = needEncoding(scheme);

  if (shouldEncode) {
    return decodeUri(defaultValue);
  }

  return defaultValue;
}
